var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopywrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.313 1.875H4.687a2.813 2.813 0 00-2.812 2.813v50.624a2.812 2.812 0 002.813 2.813h50.624a2.812 2.812 0 002.813-2.813V4.688a2.812 2.812 0 00-2.813-2.813zM4.687 3.75h50.626a.937.937 0 01.937.938v4.687H3.75V4.687a.937.937 0 01.938-.937zm50.626 52.5H4.687a.938.938 0 01-.937-.938V11.25h52.5v44.063a.938.938 0 01-.938.937z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 5.625H7.5V7.5H5.625V5.625zM9.375 5.625h1.875V7.5H9.375V5.625zM13.125 5.625H15V7.5h-1.875V5.625zM52.5 5.625h1.875V7.5H52.5V5.625zM51.563 15H8.437a.938.938 0 00-.937.938v7.5a.937.937 0 00.938.937h43.124a.938.938 0 00.938-.938v-7.5a.938.938 0 00-.938-.937zm-.938 7.5H9.375v-5.625h41.25V22.5zM7.5 28.125h20.625V30H7.5v-1.875zM31.875 28.125H52.5V30H31.875v-1.875zM7.5 33.75h20.625v1.875H7.5V33.75zM31.875 33.75H52.5v1.875H31.875V33.75zM7.5 39.375h20.625v1.875H7.5v-1.875zM31.875 39.375H52.5v1.875H31.875v-1.875zM51.563 45H8.437a.938.938 0 00-.937.938v5.624a.937.937 0 00.938.938h43.124a.938.938 0 00.938-.938v-5.624a.938.938 0 00-.938-.938zm-.938 5.625H9.375v-3.75h41.25v3.75z",
    fill: "#F2F2F2"
  })));
}

export default SvgCopywrite;